import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DialogPage } from '../root_classes/dialog-page';
import { ConstantsModule } from '../constants/constants.module';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-company-add',
  templateUrl: './company-add.component.html',
  styleUrls: ['./company-add.component.scss']
})
export class CompanyAddComponent extends DialogPage implements OnInit {

  // Form data.
  companyAddForm = new FormGroup({
    nameControl: new FormControl('', [Validators.required]),
  });

  // Extra data.
  public buttonText: string;
  public enableAction: boolean;

  constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal, modalInstance:NgbActiveModal) {
	super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);

    // Save button infos.
    this.buttonText = "Ajouter";
    this.enableAction = true;
	}

  ngOnInit(): void {}

  /**
   * 
   */
	public save(): void {
		// Disabling button.
		this.buttonText = "Veuillez patienter ...";
		this.enableAction = false;

		var newData = {
		"name": this.companyAddForm.controls['nameControl'].value.toUpperCase(),
		};

		this.put("/api/company-add", newData, 
			(response: any) => {
				if (response.DATA == "ERR") {
					this.modalInstance.close(response.VALUE);
				} else {
					// Inserting the new element in the list.
					var newCompany = {
						_id: response.ID,
						name: newData["name"],
						active: true
					};
					this.modalInstance.dismiss(newCompany);
				}
			},
			(err: any) => {
				this.modalInstance.close(err);
			}
		);
	}
}
